import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, CircularProgress } from "@mui/material";
import { getAPI } from "../api/callAPI";
import { isArray } from "lodash";
import MenuListModal from "./MenuListModal";

export default function MenuButton({ storeID, className }) {
  const { endpoint } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [menus, setMenus] = useState([]);

  // const linkURL = useMemo(() => {
  //   return endpoint === "dogandcrook"
  //     ? "https://dogandcrook.co.uk/eat"
  //     : undefined;
  // }, [endpoint]);

  const handleMenuAction = async (menu) => {
    // Priority 1: Check if uploaded_menu exists → PDF-based
    if (menu.uploaded_menu) {
      // Open PDF in new tab
      window.open(menu.uploaded_menu, "_blank", "noreferrer");
    }
    // Priority 2: Check if pdf_url exists (without uploaded_menu) → Link-based
    else if (menu.pdf_url) {
      window.open(menu.pdf_url, "_blank", "noreferrer");
    } else {
      alert("No menu available!");
    }
  };

  const handlePress = async () => {
    // If there's a specific link URL (like dogandcrook), open it directly
    // if (linkURL) {
    //   window.open(linkURL, "_blank", "noreferrer");
    //   return;
    // }

    if (!storeID) {
      alert("Store ID not available!");
      return;
    }

    setLoading(true);
    try {
      const resp = await getAPI(endpoint, `store/menu/${storeID}`);

      if (resp?.success) {
        const menuData = resp?.data;

        // Handle both single menu and array of menus
        let menuList = [];
        if (isArray(menuData)) {
          menuList = menuData;
        } else if (menuData) {
          menuList = [menuData];
        }

        // If multiple menus, show modal
        if (menuList.length > 1) {
          setMenus(menuList);
          setShowModal(true);
        }
        // If single menu, perform action directly
        else if (menuList.length === 1) {
          await handleMenuAction(menuList[0]);
        } else {
          alert("No menu available!");
        }
      } else {
        alert("No menu available!");
      }
    } catch (error) {
      console.error("handlePress error >>> ", error);
      alert("Error loading menu!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        size="large"
        onClick={handlePress}
        disabled={loading}
        className={className}
        startIcon={loading ? <CircularProgress color="primary" size={10} /> : null}
      >
        View Our Menu
      </Button>

      {/* Modal for Multiple Menus */}
      {showModal && (
        <MenuListModal
          menus={menus}
          onClose={() => setShowModal(false)}
          onMenuSelect={handleMenuAction}
        />
      )}
    </>
  );
}
